import Swiper from "swiper";

function sliderBlogCategories() {
  new Swiper('.blog__categories .swiper', {
    spaceBetween: 12,
    slidesPerView: 2,
    grabCursor: true,
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1226: {
        slidesPerView: 6,
        spaceBetween: 24,
      },
    },
  });
}
sliderBlogCategories();